const MY_PROFILE = {
  MY_PROFILE: '/profile',
  TWO_FA_INSTRUCION_GET_APP: '/profile/get-app',
  TWO_FA_INSTRUCTION_CONNECT_PHONE: '/profile/connect-phone',
  TWO_FA_INSTRUCTION_SAVE_RECOVERY: '/profile/save-recovery'
}

export default MY_PROFILE
